import { useState, useEffect, useCallback } from "react";
import { errorHandling } from "src/shared/utils/errorHandling";
import { LedgerDetails } from "src/shared/services/interfacev2";
import { getLedgerByCustomer } from "src/shared/api";

export const useCustomerData = (customerId: string, autoFetch: boolean = true) => {
  const [customer, setCustomer] = useState<LedgerDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomerData = useCallback(async () => {
    if (!customerId) return;

    setLoading(true);
    setError(null);

    try {
      // const response = await api.get(`/pos/v2/ledger/customer/${customerId}`);
      const response = await getLedgerByCustomer(customerId);
      setCustomer(response.data.ledger);
    } catch (err: any) {
      console.error("Error fetching customer data:", err);
      errorHandling(err);
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  useEffect(() => {
    if (autoFetch && customerId) {
      fetchCustomerData();
    }
  }, [customerId, autoFetch, fetchCustomerData]);

  return { customer, loading, error, refetch: fetchCustomerData };
};
